<template>
  <levensverhaal />
</template>

<script>
import Levensverhaal from '../components/OpbouwPlechtigheid/Levensverhaal.vue'

export default {
  name: 'LevensverhaalView',
  components: {
    Levensverhaal
  }
}
</script>
